import SocialMediaIcons from "./components/SocialMediaIcons";
import KascadeTitle from "./components/KascadeTitle";
import useMediaQuery from "./hooks/useMediaQuery";
import { motion } from "framer-motion";
import AnchorLink from "react-anchor-link-smooth-scroll";



import React, {useState} from 'react';
import { ethers, BigNumber} from 'ethers';
import {Box, Button, Flex, Input, Text, Center, Spacer, Image, ChakraProvider, Heading } from '@chakra-ui/react';
import ruptureNFT from './RuptureNFT.json';

import customTheme from "./theme";
import ColorModeSwitch from "./ColorModeSwitch";


const ruptureNFTAddress = "0x277B0284365fDD570416c484c5D7bA31B2503b71";


const Landing = ( {setSelectedPage} ) => {
  const isDesktop = useMediaQuery("(min-width: 1060px)");



  const basicBoxStyles = {
    display: 'stretch',
    alignItems: '',
    justifyContent: '',
    textAlign: '',
    boxSize: 'l',
    color: 'white',
    textShadow: '0 0 20px black',
    fontWeight: 'bold',
    fontSize: '20px',
    px: 0, 
    background:
      'url("https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExZ25mbmVjMnZ0am14d3I4Z3FnMXdscG5qcnNyMm5hZWF1ZnRuNTJydyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/XB7ORe1OJJJX8lCgeB/giphy.gif") center/cover ',
    w: '100%',
    h: '100%',
   
   
  
  
    }

  return (
    <Box sx ={basicBoxStyles} filter = 'hueRotate(140deg)'  display = "flex">
    <section
      id="mint"
      className="   "
      
    >
      
        {/* HEADINGS */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.5 }}
          
          variants={{
            hidden: { opacity: 0, x: -50 },
            visible: { opacity: 1, x: 0 },
          }}
        >
          {isDesktop ? (
          <Flex
          justify = "center"  align = "center"
          paddingTop={0}   
          paddingBottom={80}
          paddingLeft={0} 
          paddingRight={0}  
          >
            
            <div  >
            <Flex
            justify = "center"  align = "center"
            paddingTop={90}   
            paddingBottom={370}
            paddingLeft={0} 
            paddingRight={0}  
            
            >
            <KascadeTitle />
            </Flex>

              
                <Text fontSize="xx-large" textShadow="0 5px #000000" 
                    letterSpacing={"-5.5%"} fontFamily={"MidwinterFireRegular"} 
                      paddingBottom={20} paddingLeft = {350}
                > 
                    Every day The Rupture grows...                      
                </Text>

                  <Flex paddingTop={0} paddingLeft = {450}>
                  <div>
                  <a
                    className="bg-gradient-rainblue text-deep-blue rounded-sm py-1 px-1 font-semibold
                      hover:bg-blue hover:text-white transition duration-500 w-full h-full 
                      flex items-center justify-centerw font-midwinterfire "   
                    href="https://kas.fyi/token/krc20/KADE"
                  >
                    Minting
                  </a>
                  </div>
                  
                  <a
                    className="rounded-r-sm bg-gradient-rainblue py-1 pr-1"
                    href="https://kas.fyi/token/krc20/KADE"
                  >
                    <div>
                    <div className="bg-deep-blue hover:text-red transition duration-500 w-full h-full 
                        flex items-center justify-center py-0 px-1 font-midwinterfire">
                      Now
                    </div>
                    </div>

                  </a>
                  
                  </Flex>
                  <Flex paddingTop={0} paddingLeft = {450}>
                  <SocialMediaIcons />
                  </Flex>
                  </div>      

          </Flex>
          ) : (
          <Flex
          justify = "center"  align = "center"
          paddingTop={0}   
          paddingBottom={0}
          paddingLeft={0} 
          paddingRight={0} 
          
          >
            
            <div  >
            <Flex
            justify = "center"  align = "center"
            paddingTop={160}   
            paddingBottom={190}
            paddingLeft={80} 
            paddingRight={0}  
            >
            <KascadeTitle />

            </Flex>

              
                <Text fontSize="xx-large" textShadow="0 5px #000000" 
                    letterSpacing={"-5.5%"} fontFamily={"MidwinterFireRegular"} 
                      paddingBottom={20} paddingLeft = {50} paddingRight={50}
                > 
                    Every day The Rupture grows...                      
                </Text>

                <Flex paddingRight={200} paddingLeft = {200}>
                  <div>
                    <a
                      className="bg-gradient-rainblue text-deep-blue rounded-sm py-1 px-1 font-semibold
                        hover:bg-blue hover:text-white transition duration-500 w-full h-full 
                        flex items-center justify-centerw font-midwinterfire "
                      onClick={() => setSelectedPage("contact")}
                      href="https://kas.fyi/token/krc20/KADE"
                    >
                      Minting
                    </a>
                  </div>
                  
                  <a
                    className="rounded-r-sm bg-gradient-rainblue py-1 pr-1"
                    
                    href="https://kas.fyi/token/krc20/KADE"
                  >
                    <div>
                      <div className="bg-deep-blue hover:text-red transition duration-500 w-full h-full 
                          flex items-center justify-center py-0 px-1 font-midwinterfire">
                        Now
                      </div>
                    </div>

                  </a>
                  
                  </Flex>
                  <Flex  paddingRight={200} paddingLeft = {200}>
                  <SocialMediaIcons />
                  </Flex>
                  </div>      

          </Flex>

            
          )

        }
        
        <div className= "">
          
        </div>

      </motion.div>
      
 
    
  </section>
  </Box>
  );
};

export default Landing;
